import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UtilitiesService {
  constructor() {}

  private baseURL = "https://vjobfair.org.mk";

  private authApi = this.baseURL + "/api/v1/auth/";
  private companyStandApi = this.baseURL + "/api/v1/company/";
  private cvApi = this.baseURL + "/api/v1/cv/";
  private staticImageApi = this.baseURL + "/api/images";
  private adApi = this.baseURL + "/api/v1/ads";

  getAuthApi(path: string = ""): string {
    return this.authApi + path;
  }

  getCVApi(path: string = ""): string {
    return this.cvApi + path;
  }

  getCompanyStandApi(id: string = ""): string {
    return this.companyStandApi + id;
  }

  getStaticImageApi(): string {
    return this.staticImageApi;
  }

  getAdApi(): string {
    return this.adApi;
  }
}
